import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
    FaArrowRight, FaUserTie, FaUsers, FaBook, FaUserMd,
    FaGraduationCap, FaMicroscope, FaAward, FaCalculator,
    FaGlobe, FaBullhorn, FaBriefcase, FaUserGraduate,
    FaLaptopCode, FaSearch, FaHistory, FaDraftingCompass,
    FaRunning, FaBrain, FaBalanceScale, FaCogs, FaUsersCog,
    FaFileAlt, FaChartLine, FaUniversity, FaStethoscope, FaFlask
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "./Departments.module.css";
import { testUrl } from "../home/BaseData";

const Department = () => {
    const { t, i18n } = useTranslation();
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        axios
            .get(testUrl + "/api/centers")
            .then((response) => {
                setDepartments(response.data);
            })
            .catch((error) => console.error("Error fetching departments data: ", error));
    }, [i18n.language]);

    // Helper to find short_id for a name match
    const getLink = (nameUz) => {
        if (!departments || !nameUz) return "#";

        const normalize = (str) =>
            str.toLowerCase()
                .replace(/[“”"']/g, '"') // Standardize quotes
                .replace(/[^a-z0-9]/gi, '') // Remove all non-alphanumeric
                .trim();

        const searchName = normalize(nameUz);

        const found = departments.find(d => {
            const dbName = normalize(d.name_uz || "");
            return dbName.includes(searchName) || searchName.includes(dbName);
        });

        return found ? `/centers/${found.short_id}` : "#";
    };

    const STRUCTURE = [
        {
            id: "rektorat",
            category: "REKTORAT VA KENGASH",
            title: "Rektorat va Universitet kengashi",
            head: { name: "Rektor", role: "Universitet rahbari", icon: <FaUniversity /> },
            items: [
                { name: "Xodimlar bo'limi", icon: <FaUsersCog /> },
                { name: "Jismoniy vа yuridik shaxslarning murojaatlari bilan ishlash, arxiv, nazorat va monitoring bo‘limi", icon: <FaFileAlt /> },
                { name: "Yuristkonsult. Korrupsiyaga qarshi kurashish “Komplayens nazorat” tizimini boshqarish", icon: <FaBalanceScale /> },
                { name: "Auditor", icon: <FaSearch /> },
                { name: "Matbuot xizmati va qabul jarayonlarini muvofiqlashtirish bo‘limi", icon: <FaBullhorn /> },
                { name: "Oliy ta’lim kengashi kotibi", icon: <FaBriefcase /> }
            ]
        },
        {
            id: "yoshlar",
            category: "YOSHLAR MASALALARI",
            title: "Yoshlar masalalari va ma’naviy-ma’rifiy ishlar bo`yicha birinchi prorektor",
            head: { name: "Birinchi prorektor", role: "Yoshlar va ma’naviyat bo’yicha", icon: <FaUniversity /> },
            items: [
                { name: "Yoshlar bilan ishlash, ma’naviyat va ma’rifat, Axborot-resurs markazi bo‘limi", icon: <FaBook /> },
                { name: "Psixolog", icon: <FaBrain /> },
                { name: "Hamshira", icon: <FaStethoscope /> }
            ]
        },
        {
            id: "oquv",
            category: "O‘QUV ISHLARI",
            title: "O‘quv ishlari bo‘yicha prorektor",
            head: { name: "O'quv prorektori", role: "O‘quv jarayoni boshqaruvi", icon: <FaUniversity /> },
            items: [
                { name: "O‘quv-uslubiy boshqarma", icon: <FaGraduationCap /> },
                { name: "Marketing bo'limi", icon: <FaChartLine /> },
                { name: "Finlandiya ta'lim laboratoriyasi", icon: <FaFlask /> }
            ]
        },
        {
            id: "ilmiy",
            category: "ILMIY ISHLAR",
            title: "Ilmiy ishlar va innovatsiyalar bo’yicha prorektor",
            head: { name: "Ilmiy prorektor", role: "Innovatsiya va tadqiqotlar", icon: <FaUniversity /> },
            items: [
                { name: "Ilmiy tadqiqotlar, innovatsiyalar, ilmiy-pedagogik kadrlarni tayyorlash vа iqtidorli talabalar boshqarmasi", icon: <FaMicroscope /> }
            ]
        },
        {
            id: "sifat",
            category: "TA’LIM SIFATI",
            title: "Ta’lim sifati nazorati va raqamli texnologiyalar bo‘yicha prorektor",
            head: { name: "Sifat prorektori", role: "Ta'lim sifati va IT", icon: <FaUniversity /> },
            items: [
                { name: "Ta’lim sifatini nazorat qilish bo‘limi", icon: <FaAward /> },
                { name: "Raqamli ta'lim texnologiyalari, mahalliy va xalqaro reyting bilan ishlash boshqarmasi", icon: <FaLaptopCode /> }
            ]
        },
        {
            id: "iqtisod",
            category: "IQTISODIY ISHLAR",
            title: "Iqtisodiy va xo'jalik ishlari bo'yicha prorektor",
            head: { name: "Iqtisod prorektori", role: "Moliya va xo'jalik", icon: <FaUniversity /> },
            items: [
                { name: "Buxgalteriya, reja-moliya bo’limi", icon: <FaCalculator /> },
                { name: "Texnik-foydalanish va xo’jalik bo’limi", icon: <FaHistory /> },
                { name: "Bosh muhandis", icon: <FaCogs /> }
            ]
        },
        {
            id: "xalqaro",
            category: "XALQARO HAMKORLIK",
            title: "Xalqaro hamkorlik bo'yicha prorektor",
            head: { name: "Xalqaro prorektor", role: "Xalqaro aloqalar", icon: <FaUniversity /> },
            items: [
                { name: "Xalqaro hamkorlik bo'limi", icon: <FaGlobe /> }
            ]
        }
    ];

    return (
        <div className={styles.mainContainer}>
            <h1 className={styles.pageTitle}>{t("universityStructure") || "Universitet Tuzilmasi"}</h1>

            <div className={styles.structureList}>
                {STRUCTURE.map((section) => (
                    <div key={section.id} className={styles.sectionContainer}>
                        <div className={styles.flexLayout}>
                            {/* Left Side Side-Box */}
                            <div className={styles.sideBox}>
                                <div className={styles.sideIcon}>
                                    <FaUniversity />
                                </div>
                                <h3 className={styles.sideTitle}>{section.title}</h3>
                            </div>

                            {/* Right Side Info & Grid */}
                            <div className={styles.contentArea}>
                                <div className={styles.contentHeader}>
                                    <h2>{section.title}</h2>
                                    <p>va unga bo'ysunuvchi bo'limlar</p>
                                </div>

                                <div className={styles.itemsGrid}>
                                    {section.items.map((item, idx) => {
                                        const link = getLink(item.name);
                                        const CardComponent = link === "#" ? 'div' : Link;
                                        return (
                                            <CardComponent
                                                key={idx}
                                                to={link !== "#" ? link : undefined}
                                                className={styles.itemCard}
                                            >
                                                <div className={styles.itemIcon}>{item.icon}</div>
                                                <div className={styles.itemText}>
                                                    <h4>{item.name}</h4>
                                                </div>
                                            </CardComponent>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Department;
